export const LogLabels={SDK_CLIENT:'sdk:client',SDK_API:'sdk:Api'};